// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"7fb6e334d0acd124","5285":"f8bc6d69eed20a3b"}[chunkId] + ".css";
};